import {SellerType} from '@sollapay/enums';
import {useTranslation} from 'react-i18next';

import {PartyTypeToggle} from '@/components/roster';

import type {ButtonGroupItemDef} from '@sollapay/ui/components';
import type {FC, ReactNode} from 'react';

export interface SellerTypeToggleProps {
  value: SellerType;
  onChange: (value: SellerType) => void;
  label?: ReactNode;
  required?: boolean;
}

export const SellerTypeToggle: FC<SellerTypeToggleProps> = ({value, onChange, label, required}) => {
  const {t} = useTranslation('trustAccounts');
  const prefix = 'activation.packages.trustDetails.form.options.sellerTypes';

  const items: ButtonGroupItemDef[] = [
    {value: SellerType.CORPORATION, label: t(`${prefix}.corporation`), icon: 'building'},
    {value: SellerType.INDIVIDUAL, label: t(`${prefix}.individual`), icon: 'user'}
  ];

  return (
    <PartyTypeToggle
      className="w-fit"
      label={label}
      required={required}
      value={value}
      onChange={val => onChange(val as SellerType)}
      items={items}
    />
  );
};
